<template>
  <div class="domain-chart chart-w d-block w-100">
    <div class="domain-chart__wrapper">
      <Apexchart
        :options="chartOptions"
        :series="categories?.length ? series : []"
        :height="stylesChart.heightBarChart"
      />
    </div>

    <div class="domain-chart__menu">
      <div class="domain-chart__menu-left">
        <div class="domain-chart__title">
          {{ t('domain_blocks_stat_bar.title') }}
        </div>
      </div>
      <div
        id="chart-control"
        class="domain-chart__menu-right"
      >
        <RefreshIcon @click="loadData" />
        <CalendarInput v-model="date" />
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import { useCountryStatDomainBlocksStore } from "@/store/Analytic/chart/country-stat-domain-blocks";
import { stylesChart } from "@/tools/tooltipChart";
import VueApexCharts from "vue3-apexcharts";
import useBarChart from "@/mixins/apexChart/barChart";
import { t } from "@/controllerLK/GlobusLocalization";
import useFilterDate from "@/mixins/apexChart/filterDate";
import CalendarInput from "@/components/AnalyticsPage/AnalyticsGeneral/Charts/blocks/CalendarInput.vue";
import RefreshIcon from "@/components/Icons/RefreshIcon.vue";

export default {
  name: "DomainBlocksStatBar",
  components: {CalendarInput, Apexchart: VueApexCharts, RefreshIcon },
  setup() {
    const statStorage = useCountryStatDomainBlocksStore();

    const { date } = useFilterDate(loadData);

    async function loadData() {
      await statStorage.loadStat(date.value?.[0], date.value?.[1]);
    }
    const categories = computed(() => {
      return (statStorage.items || []).map((item) => {
        const name = item.name || "";
        return name.length > 45 ? name.slice(0, 45) + "..." : name;
      });
    });

    const series = computed(() => {
      const data = (statStorage.items || []).map((item) => item.data);
      return [{
        name: " ",
        data: data
      }];
    });

    const { chartOptions } = useBarChart(
      {
        titleText: t("domain_blocks_stat_bar.title"),
      },
      categories,
      series,
    );

    return { categories, chartOptions, date, loadData, series, stylesChart, t };
  },
};
</script>

<style lang="scss" scoped>
.domain-chart {
  &__title {
    font-size: 16px;
    font-weight: 700;
    line-height: 22px;
  }

  &__menu {
    display: flex;
    position: absolute;
    align-items: center;
    top: 24px;
    height: 42px;
    width: 100%;
    left: 0;
    padding: 0 24px;
    justify-content: space-between;

    &-left {
      display: flex;
      gap: 20px;
    }

    &-right {
      display: flex;
      gap: 14px;
    }
  }
}
</style>